// Auto-update del frontend: detecta un deploy nuevo (cambió el hash de main.js en
// asset-manifest.json) y aplica la versión nueva SIN que el agente tenga que hacer
// hard-refresh. El service worker es push-only (no cachea assets), así que esto es lo
// único necesario.
//
// REGLA DE ORO (pedido de Andy): NUNCA recargar en el medio del trabajo de alguien.
// Mientras el usuario está escribiendo (foco en un input) o hay trabajo sin guardar en
// memoria (respuesta a medio redactar, modal de resolver abierto con texto — ver
// utils/unsavedWork.js), NO se auto-recarga. En su lugar se muestra una barra no
// intrusiva con un botón "Actualizar ahora" para que el agente aplique cuando quiera, y
// la actualización automática recién dispara cuando queda ocioso y sin trabajo pendiente.

let currentMain = null;
let pending = false;   // hay una versión nueva esperando aplicarse
let banner = null;
let idleSince = null;  // timestamp desde el cual el usuario está ocioso y sin trabajo

// Cuánto tiene que estar ocioso (sin tipear, sin drafts) antes de auto-aplicar.
const IDLE_GRACE_MS = 15 * 1000;

function readCurrentMain() {
  const src = Array.from(document.querySelectorAll('script[src]'))
    .map((e) => e.getAttribute('src') || '')
    .find((s) => /\/static\/js\/main\.[0-9a-f]+\.js/.test(s));
  return src ? src.replace(/^https?:\/\/[^/]+/, '') : null;
}

async function fetchLatestMain() {
  try {
    const r = await fetch('/asset-manifest.json', { cache: 'no-store' });
    if (!r.ok) return null;
    const m = await r.json();
    return (m.files && m.files['main.js']) || m['main.js'] || null;
  } catch { return null; }
}

function applyUpdate() {
  window.location.reload();
}

function showBanner() {
  if (banner) return;
  banner = document.createElement('div');
  banner.style.cssText =
    'position:fixed;top:0;left:0;right:0;z-index:99999;background:#0B3D5C;color:#fff;' +
    'font:600 13px -apple-system,Segoe UI,Roboto,sans-serif;text-align:center;padding:8px 12px;' +
    'display:flex;align-items:center;justify-content:center;gap:12px;box-shadow:0 2px 8px rgba(0,0,0,0.25);';

  const label = document.createElement('span');
  label.textContent = '🔄 Hay una versión nueva. Se aplica sola cuando termines lo que estás haciendo.';
  banner.appendChild(label);

  const btn = document.createElement('button');
  btn.textContent = 'Actualizar ahora';
  btn.style.cssText =
    'background:#29ABE2;color:#fff;border:0;border-radius:6px;padding:5px 12px;cursor:pointer;' +
    'font:700 12px -apple-system,Segoe UI,Roboto,sans-serif;';
  btn.onclick = applyUpdate; // el usuario decide: aplica ya, aunque estuviera escribiendo
  banner.appendChild(btn);

  document.body.appendChild(banner);
}

// ¿Está el usuario escribiendo justo ahora?
function isTyping() {
  const ae = document.activeElement;
  return !!ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable);
}

// ¿Hay trabajo sin guardar en memoria que un reload perdería?
function hasUnsavedWork() {
  try { return !!(window.__hdHasUnsavedWork && window.__hdHasUnsavedWork()); }
  catch { return false; }
}

// Ocupado = escribiendo O con trabajo sin guardar. No auto-recargar si está ocupado.
function isBusy() {
  return isTyping() || hasUnsavedWork();
}

// Auto-aplica sólo si el usuario estuvo ocioso y sin trabajo pendiente por IDLE_GRACE_MS
// seguidos. Si en cualquier momento vuelve a estar ocupado, se resetea el reloj. Así una
// pausa breve entre teclas no dispara el reload en el medio de una respuesta.
function maybeAutoApply() {
  if (!pending) return;
  if (isBusy()) { idleSince = null; return; }
  const now = Date.now();
  if (idleSince == null) { idleSince = now; return; }
  if (now - idleSince >= IDLE_GRACE_MS) applyUpdate();
}

async function check() {
  if (pending) { maybeAutoApply(); return; }
  const latest = await fetchLatestMain();
  if (latest && currentMain && latest !== currentMain) {
    pending = true;
    idleSince = isBusy() ? null : Date.now();
    showBanner();
    // Chequeo frecuente mientras hay una actualización esperando, para aplicar apenas
    // el agente quede libre (sin depender del intervalo lento de 5 min).
    setInterval(maybeAutoApply, 3000);
  }
}

export function startVersionWatcher() {
  if (window.location.hostname === 'localhost') return;
  currentMain = readCurrentMain();
  if (!currentMain) return;
  setInterval(check, 5 * 60 * 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) check(); });
  window.addEventListener('focus', check);
}
